<template>
    <div class="contract">
        <div class="searchPart">
            <div style="display: flex; align-items: center">
                <el-input v-model="partner" placeholder="合作方"></el-input>
                <el-input v-model="name" placeholder="合同名称"></el-input>
<!--                <el-input v-model="status" placeholder="合同状态"></el-input>-->
                <el-select v-model="status" clearable placeholder="合同状态">
                    <el-option value="DRAFT" label="草稿"></el-option>
                    <el-option value="AUDIT" label="待卖家确认"></el-option>
                    <el-option value="CONFIRM" label="待确认"></el-option>
                    <el-option value="DONE" label="待用印"></el-option>
                    <el-option value="RELEASE" label="用印完成"></el-option>
                </el-select>
                <el-button class="searchBtn" @click="search">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="reset">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="toolRight">
<!--                <el-button type="text" size="small" @click="toDialog('add')">新增</el-button>-->
                <el-button type="primary" size="small" @click="toDialog('add')"><i class="el-icon-circle-plus-outline"></i>添加</el-button>
            </div>
        </div>
        <div class="contractTable">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                class="tableContent"
            >
            <!-- :row-style="tableRowStyle" -->
                <el-table-column
                    prop="name"
                    label="合同名称"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180"
                >
                <template slot-scope="scope">
                    <img src="../../assets/images/alert.gif" v-if="scope.row.orderByStatus.startsWith('AA')" style="width: 20px;height: 20px;vertical-align: middle;" >
                    <span>{{scope.row.name}}</span>
                 </template>
                </el-table-column>
                <el-table-column
                    prop="partner"
                    label="合作方"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.creatorUuid === $store.state.userMessages.uuid">{{scope.row.partner}}</span>
                        <span v-if="scope.row.partnerUuid === $store.state.userMessages.uuid">{{scope.row.creator}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="totalPrice"
                    label="合同金额"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="signTime"
                    label="签订时间"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="startTime"
                    label="合同开始时间"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="endTime"
                    label="合同结束时间"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="statusCn"
                    label="合同状态"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.creatorUuid === $store.state.userMessages.uuid && scope.row.status === 'AUDIT'">待卖家确认</span>
                        <span v-else-if="scope.row.partnerUuid === $store.state.userMessages.uuid && scope.row.status === 'AUDIT'">待确认</span>
                        <span v-else-if="scope.row.creatorUuid === $store.state.userMessages.uuid && scope.row.status === 'CONFIRM'">待确认</span>
                        <span v-else-if="scope.row.partnerUuid === $store.state.userMessages.uuid && scope.row.status === 'CONFIRM'">待卖家确认</span>
                        <span v-else-if="scope.row.status === 'DONE' && scope.row.sellerSign">待买家用印</span>
                        <span v-else-if="scope.row.status === 'DONE' && scope.row.buyerSign">待卖家用印</span>
                        <span v-else>{{ scope.row.statusCn }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="scope.row.status === 'DRAFT' && scope.row.creatorUuid === $store.state.userMessages.uuid" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                        <el-button type="text" size="small" v-if="scope.row.status === 'DRAFT' && scope.row.creatorUuid === $store.state.userMessages.uuid" @click="remove(scope.row.uuid)">删除</el-button>
                        <el-button type="text" size="small" v-if="scope.row.status === 'DRAFT' && scope.row.creatorUuid === $store.state.userMessages.uuid" @click="submit(scope.row.uuid)">提交</el-button>
                        <el-button type="text" size="small" v-if="scope.row.status === 'AUDIT' && scope.row.partnerUuid === $store.state.userMessages.uuid" @click="auditOpen(scope.row.uuid)">确认</el-button>
                        <el-button type="text" size="small" v-if="scope.row.status === 'CONFIRM' && scope.row.creatorUuid === $store.state.userMessages.uuid" @click="confirmOpen(scope.row.uuid)">确认</el-button>
                        <el-button type="text" size="small" @click="useSignature(scope.row.uuid)" v-if="scope.row.status === 'DONE' && !scope.row.buyerSign">用印</el-button>
                        <el-button type="text" size="small" v-if="scope.row.status === 'DONE'" @click="confirmOpen(scope.row.uuid)">查看</el-button>
                        <el-button type="text" size="small" v-if="scope.row.status === 'RELEASE'" @click="download(scope.row.finalUrl,scope.row.attachmentSecondName)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
        </div>


        <!--添加/编辑合同弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            v-loading="loading"
            width="800px">
            <div class="dialogBoxClass">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="合同名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入合同名称"></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号" prop="orderBaseUuid">
                        <el-select v-model="form.orderNo"
                                   filterable
                                   remote
                                   reserve-keyword
                                   @change="changeOrder"
                                   :remote-method="remoteMethod"
                                   :loading="searchLoading"
                                   placeholder="请搜索订单">
                            <el-option
                                v-for="item in orderOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合作方" prop="partner">
                        <el-input v-model="form.partner" readonly></el-input>

                    </el-form-item>
                    <input v-model="form.partnerUuid" type="hidden"></input>
                    <input v-model="form.orderType" type="hidden"></input>
                    <el-form-item label="合同金额" prop="totalPrice">
                        <el-input v-model="form.totalPrice" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="合同附件" prop="attachmentFirstUrl">
                        <el-upload
                            class="avatar-uploader"
                            action="/service-center/upload/file/single"
                            :file-list="fileList"
                            :before-upload="handleBeforeUpload"
                            :on-error="handleFileError"
                            :on-remove="handleRemoveFile"
                            :on-success="handleFileSuccess">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <!--                        <p class="el-upload__tip" style="font-size: 13px;line-height: normal;">请上传 590 * 375 的图片，且不超过2M</p>-->
                    </el-form-item>
                    <el-form-item label="签订时间" prop="signTime">
                        <el-date-picker type="date" placeholder="选择签订时间" v-model="form.signTime"
                                        style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="startTime">
                        <el-date-picker type="date" placeholder="选择合同开始时间" v-model="form.startTime"
                                        style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="endTime">
                        <el-date-picker type="date" placeholder="选择合同结束时间" v-model="form.endTime"
                                        style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="submitForm">保存</el-button>
                        <el-button @click="dialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>


        <!--审核/确认合同弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="confirmDialogVisible"
            :close-on-click-modal="false"
            v-loading="loading"
            width="800px">
            <div class="dialogBoxClass">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="合同名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入合同名称" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号" prop="orderBaseUuid">
                        <el-select v-model="form.orderNo"
                                   disabled
                                   filterable
                                   remote
                                   reserve-keyword
                                   @change="changeOrder"
                                   :remote-method="remoteMethod"
                                   :loading="searchLoading"
                                   placeholder="请搜索订单">
                            <el-option
                                v-for="item in orderOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合作方" prop="partner">
                        <el-input v-model="form.partner" readonly disabled></el-input>

                    </el-form-item>
                    <input v-model="form.partnerUuid" type="hidden"></input>
                    <input v-model="form.orderType" type="hidden"></input>
                    <el-form-item label="合同金额" prop="totalPrice">
                        <el-input v-model="form.totalPrice" type="number" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="合同1附件" prop="attachmentFirstUrl">
                        <span v-for="(item, index) in fileList">{{ item.name }}</span>
<!--                        <a v-for="(item, index) in fileList" :href="item.url" :download="item.name">
                           下载合同
                        </a>-->
                        <a v-for="(item, index) in fileList" href="javascript:void(0)" @click="download(item.url,item.name)">
                           下载合同
                        </a>
                    </el-form-item>
                    <el-form-item label="签订时间" prop="signTime">
                        <el-date-picker type="date" placeholder="选择签订时间" v-model="form.signTime" disabled
                                        style="width: 100%;" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="开始时间" prop="startTime">
                        <el-date-picker type="date" placeholder="选择合同开始时间" v-model="form.startTime" disabled
                                        style="width: 100%;" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间" prop="endTime">
                        <el-date-picker type="date" placeholder="选择合同结束时间" v-model="form.endTime" disabled
                                        style="width: 100%;" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="合同2附件" prop="attachmentSecondUrl" v-if="this.form.status === 'AUDIT'">
                        <el-upload
                            class="avatar-uploader"
                            action="/service-center/upload/file/single"
                            :file-list="fileList2"
                            :on-error="handleSecondFileError"
                            :on-success="handleSecondFileSuccess">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <!--                        <p class="el-upload__tip" style="font-size: 13px;line-height: normal;">请上传 590 * 375 的图片，且不超过2M</p>-->
                    </el-form-item>
                    <el-form-item label="合同2附件" prop="attachmentSecondUrl" v-else>
                        <span v-for="(item, index) in fileList2">{{ item.name }}</span>
<!--                        <a v-for="(item, index) in fileList2" :href="item.url" :download="item.name">
                            下载合同
                        </a>-->
                        <a v-for="(item, index) in fileList2" href="javascript:void(0)" @click="download(item.url,item.name)">
                            下载合同
                        </a>
                    </el-form-item>

                    <el-form-item class="submitButtonGroup" v-if="this.form.status !== 'DONE'">
                        <el-button type="primary" @click="audit" v-if="this.form.status === 'AUDIT'">确认</el-button>
                        <el-button type="primary" @click="confirm" v-if="this.form.status === 'CONFIRM'">确认</el-button>
                        <el-button @click="confirmDialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <el-dialog
            title="签章下载"
            :visible.sync="signatureDialogVisible"
            :close-on-click-modal="false"
            v-loading="loading"
            width="750px">
            <div class="contractTable">
                <el-table
                    :data="signatureList"
                    border
                    style="width: 100%"
                    class="tableContent"
                >
                    <el-table-column
                        prop="name"
                        label="签章名称"
                        header-align="center"
                        align="center"
                        show-overflow-tooltip
                        width="180"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="attachmentName"
                        label="附件"
                        header-align="center"
                        align="center"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        header-align="center"
                        align="center"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
<!--                            <a :href="scope.row.attachmentUrl" :download="scope.row.attachmentUrl">下载</a>-->
                            <a href="javascript:void(0)" @click="download(scope.row.attachmentUrl,scope.row.attachmentName)">下载</a>
                            <a href="javascript:void(0)" @click="handleSignature(scope.row.uuid)">用印</a>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @current-change="handleSignatureCurrentChange"
                    @prev-click="handleSignatureCurrentChange"
                    @next-click="handleSignatureCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="signatureCurrent"
                    :page-size="signaturePageSize"
                    :total="signatureTotal"
                    class="pagination"
                >
                </el-pagination>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {
    auditContract,
    deleteContract,
    getContractBuyerOrderByOrderNo,
    getContractInfo,
    getContractList,
    getSignatureList,
    saveContract,
    updateContract,
    updateContractStatus,
    signContract
} from "../../utils/interface";

import { downLoad } from "../../utils/downLoadModel";

export default {
    name: "contract",
    data() {
        return {
            uuid: "",
            name: "",
            partner: "",
            status: "",
            total: 0,
            current: 0,
            pageSize: 10,
            signatureTotal: 0,
            signatureCurrent: 0,
            signaturePageSize: 10,
            type: '',
            fileList: [],
            fileList2: [],
            orderOptions: [],
            tableData: [],
            signatureList: [],
            title: '',
            loading: false,
            searchLoading: false,
            form: {
                uuid: '',
                name: '',
                orderBaseUuid: '',
                orderNo: '',
                partner: '',
                partnerUuid: '',
                totalPrice: '',
                signTime: '',
                startTime: '',
                endTime: '',
                attachmentFirstUrl: '',
                attachmentFirstName: '',
            },
            pickerOptions: {
                disabledDate: (time) => {
                    return time.getTime() < Date.now() - 8.64e7;
                },
            },
            viewForm: {
                attachmentSecondUrl: '',
                attachmentSecondName: '',
            },
            rules: {
                name: [{required: true, message: '请输入合同名称', trigger: 'blur'}],
                partner: [{required: true, message: '请选择合同方', trigger: 'blur'}],
                totalPrice: [{required: true, message: '请输入合同金额', trigger: 'blur'},{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value < 0) {
                            callback(new Error("合同金额不能小于0"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change",
                }],
                signTime: [{required: true, message: '请选择签订时间', trigger: 'blur'}],
                startTime: [{required: true, message: '请选择合同开始时间', trigger: 'blur'}],
                endTime: [{required: true, message: '请选择合同结束时间', trigger: 'blur'}, {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (this.form.endTime < this.form.startTime) {
                            callback(new Error("结束时间不能小于开始时间"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change",
                },],
                attachmentFirstUrl: [{required: true, message: '请上传合同附件', trigger: 'blur'}],
            },
            dialogVisible: false,
            signatureDialogVisible: false,
            confirmDialogVisible: false
        };
    },
    created() {
        this.search();
        this.getSignatureList();
    },
    methods: {
        tableRowStyle({ row, rowIndex }) {
            let rowBackground = {};
            if (row.orderByStatus.startsWith("AA")) {
                rowBackground.background = "red";
                return rowBackground;
            }
        },
        useSignature(uuid) {
            this.uuid = uuid;
            this.signatureDialogVisible = true
        },
        getSignatureList() {
            let params = {
                current: this.signatureCurrent,
                pageSize: this.signaturePageSize
            };
            getSignatureList(params).then((res) => {
                this.signatureList = res.list;
                this.signatureCurrent = res.current;
                this.signatureTotal = res.total;
            });
        },
        remoteMethod(query) {
            if (query !== '') {
                this.searchLoading = true;
                getContractBuyerOrderByOrderNo(query).then((res) => {
                    this.searchLoading = false;
                    if (res.success) {
                        this.orderOptions = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.orderOptions = [];
            }
        },

        changeOrder(value) {
            this.orderOptions.forEach((item) => {
                if (item.value === value) {
                    this.$set(this.form, 'partner', item.creator);
                    this.$set(this.form, 'orderBaseUuid', value);
                    this.$set(this.form, 'orderNo', item.orderNo);
                    this.$set(this.form, 'partnerUuid', item.creatorUuid);
                    this.$set(this.form, 'orderType', item.orderType);
                }
            })
        },
        search() {
            let params = {
                name: this.name,
                partner: this.partner,
                status: this.status,
                current: this.current,
                pageSize: this.pageSize
            };
            getContractList(params).then((res) => {
                this.current = res.current;
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        reset() {
            this.name = '';
            this.partner = '';
            this.status = '';
            this.current = 1;
            this.search();
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.search();
        },
        // 分页
        handleSignatureCurrentChange(val) {
            this.signatureCurrent = val;
            this.getSignatureList();
        },
        // 点击打开添加/编辑合同弹出框
        toDialog(type, uuid) {
            this.type = type
            this.dialogVisible = true
            this.form = {
                name: '',
                orderBaseUuid: '',
                orderNo: '',
                partner: '',
                partnerUuid: '',
                totalPrice: '',
                signTime: '',
                startTime: '',
                endTime: '',
                attachmentFirstUrl: '',
                attachmentFirstName: '',
            }
            this.fileList = [];

            if (type === 'add') {
                this.title = '添加合同'
            } else {
                this.title = '编辑合同'
                getContractInfo(uuid).then((res) => {
                    if (res.success) {
                        this.form = res.data;
                        this.fileList.push({name: this.form.attachmentFirstName, url: this.form.attachmentFirstUrl})
                    }
                });
            }
        },

        remove(uuid) {
            this.$confirm('确定要删除该合同吗' + '?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteContract(uuid).then((res) => {
                    if (res.success) {
                        this.$message.success("删除成功");
                        this.search()
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },

        submit(uuid) {
            this.$confirm('确定要提交该合同吗' + '?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateContractStatus(uuid,'AUDIT').then((res) => {
                    if (res.success) {
                        this.$message.success("提交成功");
                        this.search()
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },

        auditOpen(uuid) {
            this.fileList = [];
            this.fileList2 = [];
            getContractInfo(uuid).then((res) => {
                if (res.success) {
                    this.confirmDialogVisible = true;
                    this.form = res.data;
                    this.fileList.push({name: this.form.attachmentFirstName, url: this.form.attachmentFirstUrl})
                }
            });
        },

        audit() {
            if(this.fileList2.length < 1) {
                this.$message.error('请上传合同2附件!');
                return;
            }
            this.$confirm('确定要确认通过该合同吗' + '?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {uuid:this.form.uuid,attachmentSecondName: this.form.attachmentSecondName, attachmentSecondUrl: this.form.attachmentSecondUrl}
                auditContract(params).then((res) => {
                    if (res.success) {
                        this.$message.success("确认成功");
                        this.confirmDialogVisible = false;
                        this.search();
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },

        confirmOpen(uuid) {
            this.fileList = [];
            this.fileList2 = [];
            getContractInfo(uuid).then((res) => {
                if (res.success) {
                    this.confirmDialogVisible = true;
                    this.form = res.data;
                    this.fileList.push({name: this.form.attachmentFirstName, url: this.form.attachmentFirstUrl})
                    this.fileList2.push({name: this.form.attachmentSecondName, url: this.form.attachmentSecondUrl})
                }
            });
        },

        confirm() {
            this.$confirm('确定要确认通过该合同吗' + '?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateContractStatus(this.form.uuid, 'DONE').then((res) => {
                    if (res.success) {
                        this.$message.success("确认成功");
                        this.confirmDialogVisible = false;
                        this.search();
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },

        // 模板附件
        handleFileSuccess(res, file) {
            this.fileList = [file];
            this.$set(this.form, 'attachmentFirstUrl', res.url);
            this.$set(this.form, 'attachmentFirstName', res.name);
            this.$refs.ruleForm.validateField('attachmentFirstUrl');
        },

        handleChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList = [fileList[fileList.length - 1]]
            }
        },

        handleSelectChange(currentRow) {
            console.log(currentRow);
        },

        handleRemoveFile(file, fileList) {
          this.form.attachmentFirstName = ''
          this.form.attachmentFirstUrl = '';
        },
        handleBeforeUpload(file){
            const fileTypes = ['.doc','.docx'];
            let fileTypeIndex = file.name.lastIndexOf('.')
            const fileNameLen = file.name.length
            const fileTypeName = file.name.substring(fileTypeIndex, fileNameLen)
            const fileIndex = fileTypes.indexOf(fileTypeName);
            if (fileIndex === -1) {
                this.$alert("只能word文档", "提示", {
                    confirmButtonText: "确定",
                })
            }
            return fileIndex !== -1
        },
        handleFileError(err, file, fileList) {
            this.$message.error(err);
        },

        // 模板附件
        handleSecondFileSuccess(res, file) {
            this.fileList2 = [file];
            this.$set(this.form, 'attachmentSecondUrl', res.url);
            this.$set(this.form, 'attachmentSecondName', res.name);
        },

        handleSecondChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList2 = [fileList[fileList.length - 1]]
            }
        },

        handleSecondFileError(err, file, fileList) {
            this.$message.error(err);
        },

        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (this.type === 'edit') {
                        updateContract(this.form, this.form.uuid).then((res) => {
                            if (res.success) {
                                this.$message.success("编辑成功");
                                this.dialogVisible = false;
                                this.search()
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false
                        });
                    } else {
                        saveContract(this.form).then((res) => {
                            if (res.success) {
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                                this.search()

                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false
                        });
                    }
                    this.type = ''
                } else {
                    this.dialogVisible = true;
                    this.loading = false
                    // return false;
                }
            });
        },
        download(url,name) {
            // 用fetch发送请求
            fetch(url).then((res) => {
                res.blob().then((blob) => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    // 这里的文件名根据实际情况从响应头或者url里获取
                    const filename = name;
                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            });
        },
        handleSignature(signatureUuid){
            signContract(this.uuid,signatureUuid).then(res=>{
                if (res.success) {
                    this.$message.success("用印成功");
                    this.signatureDialogVisible=false;
                    this.search()
                }else{
                    this.$message.error(res.message);
                }
            })
        }

    }
};
</script>

<style lang="less" scoped>
.searchPart {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    /deep/ .el-input {
        width: initial;
        margin-bottom: 22px;
        margin-right: 30px;
    }

    /deep/ .el-input__inner {
        width: 242px;
        height: 35px;
        min-height: 35px;
        font-size: 12px;
        color: #999999;
        background-color: #f2f4f7;
        border: 1px solid #f2f4f7;
        border-radius: 5px;

        &:hover,
        &:focus {
            background-color: #fff;
            border: 1px solid #108ee9;
        }
    }

    /deep/ .el-input__prefix {
        top: -3px;
    }

    /deep/ .el-input__suffix {
        top: 2px;
    }

    /deep/ .el-button {
        display: block;
        line-height: 35px;
        padding: 0;
        height: 35px;
    }

    .searchBtn {
        width: 82px;
        background: #3d7fff;
        border: none;
        border-radius: 15px;
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 22px;
    }

    .resetBtn {
        color: #333333;
        margin-bottom: 22px;
    }
}

.contract {
    padding: 20px;
}

.contractTable {
    .tableContent {
        min-height: 650px;
    }
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

.toolRight{
    button{
        width: 83px;
        height: 30px;
        background: rgba(21, 126, 251, 1);
        border: none;
        border-radius: 15px;
        font-size: 13px;
        color: #fff;
        i{
            padding-right: 5px;
        }
        &:hover{
            background: #61a2f0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/contract/contractManage.vue